import * as React from "react";
import { styled } from "@mui/material/styles";
import classNames from "classnames";
import {
  Box,
  Typography,
  Avatar,
  Paper,
} from "@mui/material";
import PersonIcon from '@mui/icons-material/Person';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { htmlSerializerBreak } from '../../../common/helpers/htmlSerializer';

import ChatItemLoading from '../ChatItemLoading';
import { Roles } from '../../../common/types/enum';
// import { MessageWithDiagram } from '../../Elements/MessageWithDiagram';

export type MessageType = {
  id: number;
  text: string;
  role: Sender;
  progress?: number;
}

type Sender = 'Assistance' | 'User' | 'Error'

type MessageProps = {
  message: MessageType
}

const ChatItem: React.FC<MessageProps> = (props) => {
  const message = props.message;
  const isAssistance = message.role === Roles.Assistance;
  const isError = message.role === Roles.Error;
  const isUser = message.role === Roles.User;
  const iLoading = message?.progress;

  let messageClass = classNames({
    'loading-message': iLoading,
    'bot-message': isAssistance,
    'user-message': !isAssistance,
    'error-message': isError
  });

  // let messageComponent = <MessageWithDiagram>{message.text}</MessageWithDiagram>

  return (
    <StyledBox className={`message ${messageClass}`}>
      <Avatar className="message__avatar" sx={{ bgcolor: isAssistance ? "primary.main" : "#575A63" }}>
        {isAssistance &&
          <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_204_3)">
              <path fillRule="evenodd" clipRule="evenodd" d="M15.6737 0.5H15.2609C13.0722 0.585313 10.9462 1.365 9.12311 2.55938C8.24436 3.13969 7.43374 3.82594 6.73124 4.61156C4.56843 4.64844 2.43249 5.55969 0.915302 7.10281C0.749052 7.27781 0.860302 7.60313 1.0978 7.64156C1.54276 7.70757 1.98805 7.771 2.43329 7.83442C2.85234 7.89412 3.27135 7.95381 3.68999 8.01563C3.64212 8.07064 3.59333 8.12481 3.54455 8.17897C3.48667 8.24324 3.42879 8.30749 3.37249 8.37313C3.27811 8.47688 3.26186 8.64156 3.33593 8.76094C3.37136 8.81629 3.41847 8.8622 3.46541 8.90796C3.48181 8.92394 3.49819 8.93991 3.51405 8.95625C4.51879 9.96052 5.52318 10.965 6.52761 11.9695C6.86183 12.3037 7.19606 12.6379 7.5303 12.9722C7.54618 12.9878 7.56177 13.0038 7.57737 13.0198C7.6232 13.0668 7.6691 13.1138 7.72249 13.1525C7.83561 13.2338 8.00186 13.2275 8.10999 13.1397C8.18885 13.0755 8.26421 13.0072 8.33957 12.9388C8.38754 12.8953 8.4355 12.8518 8.48436 12.8094C8.54236 13.2109 8.5998 13.6126 8.65725 14.0142C8.72175 14.4652 8.78626 14.9163 8.85155 15.3672C8.8728 15.5578 9.0878 15.6903 9.26936 15.6378C9.38245 15.6113 9.46149 15.5265 9.53834 15.444C9.55833 15.4226 9.57817 15.4013 9.59842 15.3813C11.0231 13.8794 11.8512 11.835 11.8897 9.76656C12.9509 8.81625 13.8331 7.6725 14.5162 6.42375C15.3887 4.82125 15.9528 3.0275 16 1.19531V0.813125C15.9831 0.64625 15.8425 0.5075 15.6737 0.5ZM10.2125 3.9325C10.4775 3.65 10.8447 3.46688 11.2297 3.42375C11.6972 3.36781 12.1853 3.52156 12.534 3.83875C12.8625 4.13063 13.065 4.5575 13.0841 4.99656C13.1078 5.44438 12.9412 5.89875 12.6309 6.22281C12.3403 6.53313 11.9262 6.7225 11.5015 6.74094C11.0459 6.765 10.5834 6.59031 10.2584 6.27C9.9428 5.96563 9.75843 5.53094 9.75686 5.0925C9.75093 4.66625 9.91718 4.24031 10.2125 3.9325ZM3.71688 11.2158C3.11125 11.0793 2.44781 11.2352 1.96938 11.6318C1.65942 11.8751 1.47907 12.2336 1.30515 12.5792C1.29373 12.6019 1.28234 12.6245 1.27094 12.6471C0.852188 13.5296 0.535938 14.4558 0.229375 15.3818C0.204034 15.465 0.177221 15.5479 0.150409 15.6307C0.0962137 15.7982 0.0420225 15.9656 0 16.1364V16.2027C0.0196875 16.3583 0.150938 16.4849 0.307188 16.4999H0.363438C0.797004 16.3812 1.22329 16.2367 1.64915 16.0923C1.73006 16.0649 1.81095 16.0374 1.89188 16.0102C2.62938 15.7505 3.36563 15.4799 4.06281 15.1236C4.28813 15.0033 4.51656 14.8805 4.70563 14.7061C5.0375 14.3889 5.25438 13.9555 5.31375 13.5005C5.37813 13.0293 5.2725 12.5371 5.01969 12.1343C4.73188 11.6699 4.25156 11.3299 3.71688 11.2158Z" fill="white"/>
            </g>
            <defs>
              <clipPath id="clip0_204_3">
                <rect width="16" height="16" fill="white" transform="translate(0 0.5)"/>
              </clipPath>
            </defs>
          </svg>
        }
        {isError && <ErrorOutlineIcon/>}
        {isUser && <PersonIcon />}
      </Avatar>
      <Paper className="message__body" variant="outlined">
        {
          (iLoading && message.progress) ?
          <ChatItemLoading text={message.text} progress={message.progress} /> :
          // <MessageWithDiagram>{message.text}</MessageWithDiagram>
          <Typography variant="body1" dangerouslySetInnerHTML={{ __html: htmlSerializerBreak(message.text) }}></Typography>
        }
      </Paper>
    </StyledBox>
  );
}

export default ChatItem;

const StyledBox = styled(Box)(({ theme }) => ({
  display: "flex",
  marginBottom: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    marginBottom: theme.spacing(1.5),
  },

  '& .message__avatar': {
    marginRight: 13,
    marginTop: 13,
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      marginRight: 10,
      marginTop: 6,
    },
  },
  '& .message__body': {
    width: '100%',
    marginRight: '60px',
    padding: theme.spacing(2.5, 3),
    borderRadius: 14,
    border: '1px solid #E3E3E3',
    background: '#ffffff',
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(2, 2.5),
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1.5, 2),
    },

    '& .MuiTypography-root': {
      fontSize: 16,
      fontWeight: 500,
      [theme.breakpoints.down('md')]: {
        fontSize: 15,
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: 14,
      },
    },
  },
  '&.user-message': {
    '& .message__body': {
      border: '1px solid #BAE0C0',
      background: '#FAFFFA',
    }
  },
  '&.loading-message': {
    '& .message__body': {
      border: '1px solid #E3E3E3',
      background: '#ffffff',
    }
  },
  '&.error-message': {
    '& .message__body': {
      fontStyle: 'italic',
      color: '#FF6347',
    }
  }
}));
